import React from "react";
import "../styles/Pages.css";
import { company } from "../data/site";

// California Online Privacy Protection Act (CalOPPA, Bus. & Prof. Code §22575–22579)
// requires any commercial website that collects personally identifiable information
// from California residents to post a privacy policy. Have the client review this text.
const EFFECTIVE_DATE = "October 20, 2026";

export default function Privacy() {
	return (
		<>
			<title>Privacy policy | B & H Machining</title>
			<meta name="description" content="How B & H Machining collects and uses information submitted through this website." />

			<section className="page-head">
				<div className="wrap">
					<h1>Privacy policy</h1>
					<p className="muted">Effective {EFFECTIVE_DATE}</p>
				</div>
			</section>

			<div className="wrap">
				<article className="prose">
					<p>
						This policy explains what information {company.legalName} ("B & H," "we") collects
						through bh-machining.com and how we use it.
					</p>

					<h2>Information we collect</h2>
					<p>When you send a quote request, we collect the details you enter:</p>
					<ul>
						<li>Name and, if you provide it, company name</li>
						<li>Email address and, if you provide it, phone number</li>
						<li>The project details you write in the message</li>
					</ul>
					<p>
						Our hosting provider may record standard technical information, such as IP address,
						browser type and the pages requested, to operate and secure the site.
					</p>

					<h2>How we use it</h2>
					<p>
						We use your information only to respond to your request, prepare quotes, and
						communicate with you about your order. We do not sell or rent your personal
						information, and we do not share it for advertising.
					</p>

					<h2>Service providers</h2>
					<p>We rely on a few third-party services to run this site:</p>
					<ul>
						<li>Google Firebase, to host the website</li>
						<li>EmailJS, to deliver quote requests to our inbox</li>
						<li>Google reCAPTCHA, to block spam on the quote form</li>
					</ul>
					<p>
						These providers process data on our behalf under their own privacy policies. Google
						reCAPTCHA is subject to the{" "}
						<a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
							Google Privacy Policy
						</a>{" "}
						and{" "}
						<a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
							Terms of Service
						</a>
						.
					</p>

					<h2>Cookies and Do Not Track</h2>
					<p>
						This site does not use advertising or analytics cookies. Google reCAPTCHA may set
						cookies needed to tell people from bots. Because we do not track visitors across
						sites, we do not change our practices in response to browser Do Not Track signals.
					</p>

					<h2>Reviewing or deleting your information</h2>
					<p>
						To see, correct or delete the information you sent us, email{" "}
						<a href={`mailto:${company.email}`}>{company.email}</a> or call{" "}
						<a href={company.phoneHref}>{company.phone}</a>.
					</p>

					<h2>Children</h2>
					<p>This site is intended for businesses and is not directed to children under 13.</p>

					<h2>Changes to this policy</h2>
					<p>
						If we change this policy, we will post the new version here and update the effective
						date above.
					</p>

					<h2>Contact</h2>
					<p>
						{company.legalName}
						<br />
						{company.street}, {company.city}, {company.region} {company.postal}
						<br />
						<a href={`mailto:${company.email}`}>{company.email}</a>
					</p>
				</article>
			</div>
		</>
	);
}
